import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    initialized: false,
    header_locked: true,
    rule: null,
    tint: 'orange',
    alert: null,
    open_training: null,
    is_demo: false,
    action_completed: 0
  },
  mutations: { 
    'HEADER_LOCKED' (state, b) {
      state.header_locked = b
    },
    'SET_RULE' (state, rule) {
      state.rule = rule
    },
    'SET_TINT' (state, tint) {
      state.tint = tint
    },
    'INITIALIZED' (state) {
      state.initialized = true
    },
    'ADD_ALERT' (state, type) {
      state.alert = type
    },
    'OPEN_TRAINING' (state, indice) {
      state.open_training = indice
    },
    'IS_DEMO' (state, bool) {
      state.is_demo = bool
    },
    'ACTION_COMPLETED' (state) {
      state.action_completed += 1
    },
  },
  getters: {
    header_locked: state => state.header_locked,                  
    rule: state => state.rule,                      
    tint: state => state.tint,                      
    initialized: state => state.initialized,                      
    alert: state => state.alert,                     
    open_training: state => state.open_training,                     
    is_demo: state => state.is_demo,                     
    action_completed: state => state.action_completed,                     
  }
}


